var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPlayWhite = function SvgIcPlayWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.916 5.265 2.9.972a.78.78 0 0 0-1.185.658v8.585a.776.776 0 0 0 1.187.659L9.916 6.58a.77.77 0 0 0 0-1.315v-.001m-7.422 4.941v-8.57l7.005 4.287-7.005 4.283"
  })));
};
export default SvgIcPlayWhite;